<template>
  <div class="itinerary-box bg-blue-300 print-no-overlap">
    <ScreenWidthProvider
      v-slot="{ isWider, isNarrower }"
      class="flex flex-col md:flex-row"
    >
      <div
        v-if="isWider('md') || (isNarrower('md') && hasTitle)"
        class="itinerary-box-icon flex flex-row justify-center grow print-hidden itinerary-box-icon-color py-4 md:py-4 text-blue-700 items-center md:items-start px-4 md:px-0"
      >
        <fa
          v-if="boxType === boxTypes.hotel"
          class="min-h-[25px]"
          :icon="icons.faHotel"
        />
        <FaSharpSolidCircleInfoSVG
          v-else
          class="min-h-[25px]"
          fill="currentColor"
        />
        <h5 class="block md:hidden ml-2 pl-1 mb-0">
          <span
            v-if="itineraryDay.title"
            :data-i18n="itineraryDay.title_translationkey"
          >{{ itineraryDay.title }}</span>
          <span
            v-else
            data-i18n="itineraryBoxTitle"
          >{{ $t('itineraryBoxTitle') }}</span>
        </h5>
      </div>
      <ItineraryDay
        class="ml-0 md:-ml-4"
        :is-destination="isDestination"
        :itinerary-day="itineraryDay"
        color="transparent"
        :allow-fullscreen="allowFullscreen"
        :allow-open-map="allowOpenMap"
        :slider-navigation="sliderNavigation"
        :text-class="textClass"
        @show-preview="showPreview"
      />
    </ScreenWidthProvider>
    <LazyMediaModal
      v-if="mediaModal"
      :visible="mediaModal"
      :title="modalTitle"
      :media-list="mediaList"
      :default-current-index="currentIndex"
      size="xl"
      centered
      show-close
      @on-hide="hidePreview"
    />
  </div>
</template>

<script>
import { faHotel } from '@fortawesome/pro-regular-svg-icons'
import FaSharpSolidCircleInfoSVG from '@fortawesome/fontawesome-pro/svgs/sharp-solid/circle-info.svg'

import { boxTypes } from '@packages/trip/constants/types.ts'

export default defineNuxtComponent({
  components: {
    FaSharpSolidCircleInfoSVG,
  },

  props: {
    itineraryDay: {
      type: Object,
      default: () => ({}),
    },

    boxType: {
      type: String,
      default: 'day',
    },

    isDestination: {
      type: Boolean,
      default: false,
    },

    allowFullscreen: {
      type: Boolean,
      default: true,
    },

    allowOpenMap: {
      type: Boolean,
      default: true,
    },

    sliderNavigation: {
      type: Boolean,
      default: true,
    },

    textClass: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      boxTypes,
      icons: {
        faHotel,
      },
      mediaModal: false,
      currentIndex: 0,
      mediaList: [],
      modalTitle: '',
    }
  },

  computed: {
    hasTitle () {
      return this.itineraryDay.title || this.boxType === boxTypes.generalInfo
    },
  },

  methods: {
    hidePreview () {
      this.mediaModal = false
    },

    showPreview ({ currentIndex, mediaList, title }) {
      this.modalTitle = title
      this.mediaModal = true
      this.currentIndex = currentIndex

      this.mediaList = mediaList.map(media => ({
        ...media,
        type: media.type === 'cloudinary_image' ? 'cloudinary' : media.type,
        mediatype: media.type === 'cloudinary_image' ? 'image' : media.type,
      }))
    },
  },
})
</script>

<style lang="scss">
.itinerary-box {
  .product-itinerary__item-title {
    margin-bottom: 5px !important;

    @media (max-width: calc(theme('screens.md') - 1px)) {
      display: none;
    }
  }

  &-icon {
    &-color {
      min-width: 120px;
      max-width: 120px;

      @media (min-width: theme('screens.md')) {
        svg {
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
    }

    h5 {
      font-size: 1.25rem;
    }

    svg {
      height: auto;
      width: 100%;

      @media (max-width: calc(theme('screens.md') - 1px)) {
        width: unset;
      }
    }

    @media (max-width: calc(theme('screens.md') - 1px)) {
      background: theme('colors.blue.DEFAULT');
      color: white !important;
      min-width: 100%;

      svg {
        width: unset;
        max-height: 25px;
      }
    }
  }
}
</style>
